// One window event for "something in Inventory changed" — a request raised or
// decided, an order approved. The sidebar badges and the "Waiting for you" strip
// listen for it, so a decision taken on one screen is reflected on every other
// without a reload.
export const INVENTORY_CHANGED = 'inventoryChanged';

export const notifyInventoryChanged = () => {
  try { window.dispatchEvent(new Event(INVENTORY_CHANGED)); } catch { /* old browsers */ }
};
